export default "__VITE_ASSET__DXLg6KG1__"